module.exports = __webpack_public_path__ + "img/max-speed.268d3f94.svg";